exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select-country {\n  width: 100%;\n}\nselect-country select {\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"plugins":[{}]}!./src/app/common/components/select-country/select-country.component.less
// module id = P8+L
// module chunks = 1